import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { COOKIE_CATEGORIES, DEFAULT_CONSENT } from '../utils/cookieConsent';

function CategoryToggle({ category, checked, onChange }) {
  const disabled = category.required;
  return (
    <div className="cookie-consent-category">
      <div className="cookie-consent-category__header">
        <div>
          <h3 className="cookie-consent-category__title">{category.label}</h3>
          {category.required && (
            <span className="cookie-consent-category__badge">Immer aktiv</span>
          )}
        </div>
        <label className={`cookie-consent-toggle${disabled ? ' cookie-consent-toggle--disabled' : ''}`}>
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span className="cookie-consent-toggle__track" aria-hidden="true">
            <span className="cookie-consent-toggle__thumb" />
          </span>
        </label>
      </div>
      <p className="cookie-consent-category__desc">{category.description}</p>
    </div>
  );
}

const CookieConsent = () => {
  const {
    ready,
    hasChoice,
    categories,
    settingsOpen,
    openSettings,
    closeSettings,
    updateConsent,
    acceptAll,
    rejectOptional,
  } = useCookieConsent();

  const [draft, setDraft] = useState(DEFAULT_CONSENT);
  const showBanner = ready && !hasChoice && !settingsOpen;

  useEffect(() => {
    if (settingsOpen) setDraft(categories);
  }, [settingsOpen, categories]);

  return (
    <>
      {showBanner && (
        <div className="cookie-consent-banner" role="dialog" aria-labelledby="cookie-consent-title">
          <div className="cookie-consent-banner__inner">
            <div className="cookie-consent-banner__text">
              <h2 id="cookie-consent-title" className="cookie-consent-banner__title">
                Cookie-Einstellungen
              </h2>
              <p className="cookie-consent-banner__desc">
                Wir verwenden technisch notwendige Speicher (z. B. Login) und – mit deiner Einwilligung –
                optionale Cookies für Komfort und Statistik.{' '}
                <Link to="/cookie-richtlinien" className="cookie-consent-link">
                  Cookie-Richtlinien
                </Link>
              </p>
            </div>
            <div className="cookie-consent-banner__actions">
              <button type="button" className="cookie-consent-btn cookie-consent-btn--ghost" onClick={rejectOptional}>
                Alle ablehnen
              </button>
              <button type="button" className="cookie-consent-btn cookie-consent-btn--outline" onClick={openSettings}>
                Einstellungen
              </button>
              <button type="button" className="cookie-consent-btn cookie-consent-btn--primary" onClick={acceptAll}>
                Alle akzeptieren
              </button>
            </div>
          </div>
        </div>
      )}

      {settingsOpen && (
        <div className="cookie-consent-modal-backdrop" role="presentation" onClick={closeSettings}>
          <div
            className="cookie-consent-modal"
            role="dialog"
            aria-labelledby="cookie-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 id="cookie-modal-title" className="cookie-consent-modal__title">Cookie-Einstellungen</h2>
            <p className="cookie-consent-modal__desc">
              Wähle, welche Kategorien wir verwenden dürfen. Notwendige Speicher sind für Login und
              Tippspeicherung erforderlich.
            </p>
            <div className="cookie-consent-modal__categories">
              {Object.values(COOKIE_CATEGORIES).map((cat) => (
                <CategoryToggle
                  key={cat.id}
                  category={cat}
                  checked={draft[cat.id]}
                  onChange={(val) => setDraft((d) => ({ ...d, [cat.id]: val }))}
                />
              ))}
            </div>
            <div className="cookie-consent-modal__actions">
              <button type="button" className="cookie-consent-btn cookie-consent-btn--ghost" onClick={rejectOptional}>
                Optionale ablehnen
              </button>
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn--primary"
                onClick={() => { updateConsent(draft); closeSettings(); }}
              >
                Auswahl speichern
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
